(function (window) {
  var _window = window
  if (_window && _window.location.host.indexOf('ydt.onloon') !== -1) {
    var webMoniterScr = document.createElement('script')
    webMoniterScr.type = 'text/javascript'
    webMoniterScr.src = '//img.onloon.co/js/aliyunMonitor.js'
    webMoniterScr.id = 'mirror'
    document.head.appendChild(webMoniterScr)
  }
  if (_window) {
    var targetHidden = function () {
      var app = document.querySelector('#app')
      app && app.click()
      var inFocus = document.querySelector('.is-focus .is-reverse')
      inFocus && inFocus.click()
      var inOpened = document.querySelector('.is-opened .is-reverse')
      inOpened && inOpened.click()
      var inShow = document.querySelector('.is-show .is-reverse')
      inShow && inShow.click()
    }
    // window滚动
    _window.addEventListener('scroll', targetHidden)
    var body = document.body
    // dialog__body滚动
    body.addEventListener('DOMNodeInserted', (e) => {
      try {
        if (e && e.target && e.target.className && (typeof e.target.className === 'string') && e.target.className.includes('el-dialog__body')) {
          var cNodeList = document.querySelectorAll('.el-dialog__body')
          cNodeList.forEach((node) => {
            node.addEventListener('scroll', targetHidden)
          })
        }
      } catch (err) {
        // console.log(err)
      }
    })
  }
}(window))
